import { ArrowForwardIos } from '@interhyp/platform-icons';
import { NavigationHintConnected } from '@interhyp/platform-navigation';
import { Link, matchPath, useLocation } from '@interhyp/platform-router';
import { ResetButton, SMALL_ICON_SIZE } from '@platform/elements';
import classnames from 'classnames';
import { useMemo } from 'react';

import styles from './MobileDrawerItem.module.scss';

export function MobileDrawerItem({
  to,
  exact,
  label,
  onClick,
  showRightIcon = false,
  active = false,
}: {
  to?: string;
  exact?: boolean;
  label: string;
  onClick?: () => void;
  showRightIcon?: boolean;
  active?: boolean;
}): React.ReactElement {
  const { pathname } = useLocation();
  const activeByPath = useMemo(
    () =>
      matchPath(pathname, {
        path: to,
        exact,
      }),
    [to, exact, pathname],
  );

  const className = classnames(styles.link, {
    [styles.active]: active || activeByPath,
  });

  if (to) {
    return (
      <Link to={to} className={className} onClick={onClick}>
        <span className={styles.linkInner}>
          {label}
          <NavigationHintConnected path={to} exact={exact} />
        </span>

        {showRightIcon && <ArrowForwardIos size={SMALL_ICON_SIZE} />}
      </Link>
    );
  }
  return (
    <ResetButton className={className} onClick={onClick}>
      {label}
      {showRightIcon && <ArrowForwardIos size={SMALL_ICON_SIZE} />}
    </ResetButton>
  );
}
